const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBirthdayHat5(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 450.523,
    height: "160mm",
    viewBox: "0 0 119.201 160",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M112.595 39.507a10.775 10.775 0 0 1-.194-1.456c-.056 1.776-.031 2.158.07 1.143.142-.66.209-1.32.41-1.976.303-.989.73-1.96 1.28-2.893 1.246-2.094 3.126-4.05 5.567-5.5 2.28-1.356 5.296-2.343 8.287-1.864 2.784.449 5.027 1.987 5.31 4.083-.004-1.066-.004-2.132-.007-3.196-.06 1.579-1.341 3.12-3.465 3.65-1.538.384-3.651.069-3.958-1.254V33.5c.205-.879 1.651-1.724 2.646-.889-.219-.184.025-1.363.025-1.627 0-.308.264-1.387-.025-1.628-.84-.705-2.184-.195-2.575.587-.343.677-.096 1.666-.092 2.363 0 .582-.145 1.305.314 1.825.748.846 2.483.912 3.665.623 2.79-.68 3.472-2.638 3.493-4.514.021-1.986.23-3.87-2.018-5.315-6.117-3.934-13.79 1.263-16.57 5.228-2.664 3.793-2.91 8.443-2.163 12.61-.19-1.064.19-2.186 0-3.255",
    style: {
      fill: "#f68121",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0300693
    },
    transform: "translate(-52.965 -21.45)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.313 40.553c4.484-3.412 12.457-2.999 15.688 1.24.356.467.646.954.86 1.461.12.292.22.587.294.884.159.928.176.598.05-1-.646 1.02-.604 2.049-1.885 2.887-2.691 1.763-6.078-.251-6.152-2.51l-.01 3.035c.483-2.978 4.645-4.664 8.205-5.5 4.265-1.002 9.158-.933 13.024.846 1.588.73 2.964 1.707 3.966 2.863.494.571.906 1.181 1.189 1.825.127.287.2.579.31.868.519 1.354.43-1.658.028-.776-1.266 2.768-3.235 5.06-7.539 5.567-.268.03.201 3.231 0 3.255 7.095-.836 8.121-6.103 7.67-10.404-.635-6.117-9.793-8.88-17.17-7.601-3.45.597-7.775 1.973-9.253 4.523-.836 1.446-.79 3.87-.328 5.38.924 3.017 5.591 3.332 7.33.543 1.101-1.768.854-4.121.713-6.015-.47-6.336-10.887-9.268-16.99-4.626-.25.187-.025 1.358-.025 1.627 0 .27.276 1.438.025 1.628",
    style: {
      fill: "#94de4b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0300693
    },
    transform: "translate(-52.965 -21.45)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.666 38c.765-1.848 1.037-3.647 1.122-5.562.074-1.75.211-3.521-.734-5.177-1.934-3.383-9.151-5.459-11.629-1.235-.716 1.222-.537 2.78-.558 4.078-.022 1.394.671 3.262 3.098 3.229 2.116-.033 2.503-1.72 2.59-2.932.101-1.407.35-2.976-.164-4.357-.733-1.971-2.684-3.968-5.546-4.475-2.709-.48-5.67.525-6.576 2.465-.462.99.315 2.279-.14 3.253 1.832-3.922 8.62-2.784 11.011.113.663.802.728 1.745 1.299 2.527.155.75.18.238.077-1.543-.052.18-.132.353-.24.52-.295.28-.41.595-.82.828-2.19 1.238-4.323-.754-4.458-2.24l-.12 3.032c.214-3.068 4.804-4.432 8.265-3.08 1.793.699 3.177 1.906 3.893 3.285.226.44.378.902.49 1.366.05.184.085.369.107.559.07.605.091.371.063-.705-.325.12-.737 2.432-.889 2.796-.416 1.01.272 2.258-.141 3.255",
    style: {
      fill: "#35b1f0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0300693
    },
    transform: "translate(-52.965 -21.45)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.53 41.552c.452-2.073.653-5.023-1.5-6.628-3.188-2.378-9.205-1.632-12.638.07-3.293 1.63-3.246 3.9-3.162 6.505.07 2.211 3.27 4.964 6.393 3.242.74-.41-.697-2.873 0-3.258-2.77 1.53-6.21-.679-6.374-2.832l-.006 3.199c.691-5.667 16.204-7.538 17.39-1.207-.004-.818-.011-1.633-.018-2.45 0 .153-.004.304-.004.456.007-.27.014-.539.018-.805-.032.15-.064.302-.1.453-.229 1.064.23 2.202 0 3.255",
    style: {
      fill: "#ffd400",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0300693
    },
    transform: "translate(-52.965 -21.45)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m124.142 105.442 6.759 10.806s-12.393 8.35-28.859 13.192l-6.927-7.364 29.027-16.634",
    style: {
      fill: "#fca851",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0300693
    },
    transform: "translate(-52.965 -21.45)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.165 163.81 113.23 36.905 52.965 163.207s1.69 17.641 62.057 18.233c51.457.502 57.143-17.63 57.143-17.63",
    style: {
      fill: "#35b1f0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0300693
    },
    transform: "translate(-52.965 -21.45)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.165 163.81 113.23 36.905 52.965 163.207s1.69 17.641 62.057 18.233c51.457.502 57.143-17.63 57.143-17.63",
    style: {
      fill: "#35b1f0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0300693
    },
    transform: "translate(-52.965 -21.45)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.777 98.246c0-2.369-1.55-4.49-3.985-5.934l-6.563 13.756c5.896-.33 10.548-3.709 10.548-7.822",
    style: {
      fill: "#f68121",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0300693
    },
    transform: "translate(-52.965 -21.45)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.284 139.545c6.338 0 11.493-3.524 11.493-7.855s-5.155-7.853-11.493-7.853c-3.6 0-6.815 1.138-8.924 2.914l-2.541 5.323c.297 4.152 5.317 7.471 11.465 7.471",
    style: {
      fill: "#feb1b2",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0300693
    },
    transform: "translate(-52.965 -21.45)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.741 98.246c0 3.882 4.145 7.107 9.567 7.735l-6.177-13.3c-2.092 1.423-3.39 3.394-3.39 5.565",
    style: {
      fill: "#f68121",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0300693
    },
    transform: "translate(-52.965 -21.45)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.235 123.837c-6.34 0-11.494 3.521-11.494 7.853 0 4.331 5.154 7.855 11.494 7.855 5.224 0 9.638-2.398 11.027-5.666l-3.859-8.317c-1.968-1.077-4.459-1.725-7.168-1.725",
    style: {
      fill: "#feb1b2",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0300693
    },
    transform: "translate(-52.965 -21.45)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.259 39.43c-.424 0-.844.02-1.256.051l-6.487 13.592c2.045 1.279 4.758 2.066 7.743 2.066 2.885 0 5.517-.736 7.538-1.94l-6.374-13.728a17.494 17.494 0 0 0-1.164-.04M113.259 107.08c-6.338 0-11.494 3.522-11.494 7.853 0 4.332 5.156 7.856 11.494 7.856 6.335 0 11.493-3.524 11.493-7.856 0-4.331-5.158-7.853-11.493-7.853M147.235 157.281c-6.34 0-11.494 3.522-11.494 7.853 0 4.332 5.154 7.856 11.494 7.856 6.336 0 11.493-3.524 11.493-7.856 0-4.331-5.157-7.853-11.493-7.853",
    style: {
      fill: "#ff3636",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0300693
    },
    transform: "translate(-52.965 -21.45)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.259 73.636c-6.338 0-11.494 3.524-11.494 7.853 0 4.331 5.156 7.855 11.494 7.855 6.335 0 11.493-3.524 11.493-7.855 0-4.33-5.158-7.853-11.493-7.853",
    style: {
      fill: "#feb1b2",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0300693
    },
    transform: "translate(-52.965 -21.45)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.284 157.281c-6.338 0-11.494 3.522-11.494 7.853 0 4.332 5.156 7.856 11.494 7.856s11.493-3.524 11.493-7.856c0-4.331-5.155-7.853-11.493-7.853",
    style: {
      fill: "#ff3636",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0300693
    },
    transform: "translate(-52.965 -21.45)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.259 140.525c-6.338 0-11.494 3.521-11.494 7.853 0 4.331 5.156 7.855 11.494 7.855 6.335 0 11.493-3.524 11.493-7.855 0-4.332-5.158-7.853-11.493-7.853",
    style: {
      fill: "#f68121",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0300693
    },
    transform: "translate(-52.965 -21.45)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.235 175.522c-8.382 0-15.202-4.66-15.202-10.388s6.82-10.387 15.202-10.387 15.2 4.659 15.2 10.387c0 5.729-6.818 10.388-15.2 10.388m-33.976-83.645c-8.382 0-15.201-4.66-15.201-10.388s6.819-10.388 15.2-10.388c8.383 0 15.202 4.66 15.202 10.388s-6.82 10.388-15.201 10.388m0 33.444c-8.382 0-15.201-4.66-15.201-10.388s6.819-10.388 15.2-10.388c8.383 0 15.202 4.66 15.202 10.388s-6.82 10.388-15.201 10.388m0 33.444c-8.382 0-15.201-4.66-15.201-10.387 0-5.729 6.819-10.388 15.2-10.388 8.383 0 15.202 4.66 15.202 10.388s-6.82 10.387-15.201 10.387m-33.975 16.757c-8.382 0-15.2-4.66-15.2-10.388s6.818-10.387 15.2-10.387 15.201 4.659 15.201 10.387c0 5.729-6.819 10.388-15.201 10.388m80.622-38.109c-2.723 2.81-7.383 4.665-12.671 4.665-8.382 0-15.202-4.66-15.202-10.388s6.82-10.388 15.202-10.388c1.95 0 3.81.262 5.524.72l-6.23-13.412c-8.054-.253-14.496-4.798-14.496-10.364 0-3.327 2.311-6.287 5.881-8.19l-15.92-34.282c-2.474 1.192-5.483 1.9-8.735 1.9-3.359 0-6.455-.76-8.973-2.023L88.013 89.754c3.907 1.882 6.472 4.985 6.472 8.492 0 5.728-6.819 10.387-15.201 10.387-.092 0-.183-.008-.275-.008l-6.59 13.81a20.967 20.967 0 0 1 6.865-1.133c8.382 0 15.201 4.66 15.201 10.388s-6.819 10.387-15.201 10.387c-5.898 0-11.01-2.311-13.53-5.674l-12.79 26.804s1.691 17.64 62.058 18.233c51.457.502 57.143-17.631 57.143-17.631l-12.259-26.396",
    style: {
      fill: "#ffda3e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0300693
    },
    transform: "translate(-52.965 -21.45)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m121.993 55.774-1.196-2.575c-2.021 1.204-4.653 1.94-7.538 1.94-2.985 0-5.698-.787-7.743-2.066l-1.23 2.578c2.518 1.266 5.615 2.023 8.973 2.023 3.252 0 6.261-.708 8.734-1.9",
    style: {
      fill: "#ee3264",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0300693
    },
    transform: "translate(-52.965 -21.45)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.259 89.344c-6.338 0-11.494-3.524-11.494-7.855 0-4.33 5.156-7.853 11.494-7.853 6.335 0 11.493 3.524 11.493 7.853 0 4.331-5.158 7.855-11.493 7.855m0-18.243c-8.382 0-15.201 4.66-15.201 10.388s6.819 10.388 15.2 10.388c8.383 0 15.202-4.66 15.202-10.388S121.64 71.1 113.259 71.1",
    style: {
      fill: "#35b1f0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0300693
    },
    transform: "translate(-52.965 -21.45)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.235 172.99c-6.34 0-11.494-3.524-11.494-7.856 0-4.331 5.154-7.853 11.494-7.853 6.336 0 11.493 3.522 11.493 7.853 0 4.332-5.157 7.856-11.493 7.856m0-18.243c-8.382 0-15.202 4.659-15.202 10.387 0 5.729 6.82 10.388 15.202 10.388s15.2-4.66 15.2-10.388-6.818-10.387-15.2-10.387",
    style: {
      fill: "#feb1b2",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0300693
    },
    transform: "translate(-52.965 -21.45)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.485 98.246c0-3.507-2.565-6.61-6.472-8.492l-1.22 2.558c2.435 1.443 3.984 3.565 3.984 5.934 0 4.113-4.652 7.491-10.548 7.822l-1.22 2.558c.092 0 .183.008.275.008 8.382 0 15.201-4.66 15.201-10.388",
    style: {
      fill: "#94de4b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0300693
    },
    transform: "translate(-52.965 -21.45)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.284 142.078c8.382 0 15.201-4.66 15.201-10.388s-6.819-10.388-15.201-10.388c-2.471 0-4.8.415-6.865 1.133l-2.06 4.316c2.11-1.776 5.325-2.914 8.925-2.914 6.338 0 11.493 3.521 11.493 7.853 0 4.331-5.155 7.855-11.493 7.855-6.148 0-11.168-3.319-11.465-7.47l-2.065 4.328c2.52 3.363 7.632 5.675 13.53 5.675",
    style: {
      fill: "#9e7cdb",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0300693
    },
    transform: "translate(-52.965 -21.45)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.033 131.69c0 5.728 6.82 10.388 15.202 10.388 5.288 0 9.948-1.856 12.671-4.665l-1.644-3.534c-1.39 3.268-5.803 5.666-11.027 5.666-6.34 0-11.494-3.524-11.494-7.855s5.154-7.853 11.494-7.853c2.709 0 5.2.648 7.168 1.725l-1.644-3.54a21.39 21.39 0 0 0-5.524-.72c-8.382 0-15.202 4.66-15.202 10.388",
    style: {
      fill: "#94de4b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0300693
    },
    transform: "translate(-52.965 -21.45)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.259 156.233c-6.338 0-11.494-3.524-11.494-7.855 0-4.332 5.156-7.853 11.494-7.853 6.335 0 11.493 3.521 11.493 7.853 0 4.331-5.158 7.855-11.493 7.855m0-18.243c-8.382 0-15.201 4.66-15.201 10.388s6.819 10.387 15.2 10.387c8.383 0 15.202-4.66 15.202-10.387 0-5.729-6.82-10.388-15.201-10.388M132.033 98.246c0 5.566 6.442 10.11 14.496 10.364l-1.22-2.63c-5.423-.627-9.568-3.852-9.568-7.734 0-2.171 1.298-4.142 3.39-5.565l-1.217-2.624c-3.57 1.902-5.88 4.862-5.88 8.189M114.423 39.471l-1.193-2.565-1.227 2.575c.412-.03.832-.05 1.256-.05.391 0 .78.015 1.164.04",
    style: {
      fill: "#ee3264",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0300693
    },
    transform: "translate(-52.965 -21.45)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.284 172.99c-6.338 0-11.494-3.524-11.494-7.856 0-4.331 5.156-7.853 11.494-7.853s11.493 3.522 11.493 7.853c0 4.332-5.155 7.856-11.493 7.856m0-18.243c-8.382 0-15.2 4.659-15.2 10.387 0 5.729 6.818 10.388 15.2 10.388s15.201-4.66 15.201-10.388-6.819-10.387-15.201-10.387",
    style: {
      fill: "#35b1f0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0300693
    },
    transform: "translate(-52.965 -21.45)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.259 122.789c-6.338 0-11.494-3.524-11.494-7.856 0-4.331 5.156-7.853 11.494-7.853 6.335 0 11.493 3.522 11.493 7.853 0 4.332-5.158 7.856-11.493 7.856m0-18.244c-8.382 0-15.201 4.66-15.201 10.388s6.819 10.388 15.2 10.388c8.383 0 15.202-4.66 15.202-10.388s-6.82-10.388-15.201-10.388",
    style: {
      fill: "#ee3264",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0300693
    },
    transform: "translate(-52.965 -21.45)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.238 180.31c-14.082-1.443-23.245-4.073-29.205-6.843l1.58-3.791c2.47 3.457 7.67 5.846 13.671 5.846 8.382 0 15.201-4.66 15.201-10.388s-6.819-10.387-15.201-10.387c-2.984 0-5.77.589-8.121 1.61l5.993-14.38c.695.067 1.405.1 2.128.1 8.382 0 15.201-4.659 15.201-10.387 0-4.242-3.738-7.897-9.08-9.509l14.76-35.42c1.004 1.16 2.329 2.176 3.89 2.99l-2.187 18.31c-2.37 1.833-3.81 4.24-3.81 6.872 0 2.027.854 3.922 2.33 5.523l-7.15 59.854",
    style: {
      fill: "#ffeda0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0300693
    },
    transform: "translate(-52.965 -21.45)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.284 172.99c-6.338 0-11.494-3.524-11.494-7.856 0-.284.023-.564.066-.84l1.063-2.553c1.856-2.637 5.804-4.46 10.365-4.46 6.338 0 11.493 3.522 11.493 7.853 0 4.332-5.155 7.856-11.493 7.856",
    style: {
      fill: "#ff9c9c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0300693
    },
    transform: "translate(-52.965 -21.45)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.284 139.545c-.371 0-.738-.012-1.1-.035l6.192-14.86c3.79 1.286 6.401 3.96 6.401 7.04 0 4.331-5.155 7.855-11.493 7.855M104.44 86.522c-1.33-1.089-2.24-2.424-2.554-3.893l2.582-6.194c.393-.318.822-.616 1.283-.887l-1.31 10.974",
    style: {
      fill: "#ffd9d9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0300693
    },
    transform: "translate(-52.965 -21.45)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.055 89.752c-1.561-.815-2.886-1.83-3.89-2.991l1.721-4.132c.314 1.469 1.223 2.804 2.555 3.893l-.386 3.23m.413-13.317 1.65-3.96-.367 3.073c-.461.271-.89.569-1.283.887",
    style: {
      fill: "#9cd9f8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0300693
    },
    transform: "translate(-52.965 -21.45)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.284 142.078c-.723 0-1.433-.034-2.128-.1l1.028-2.468c.362.023.729.035 1.1.035 6.338 0 11.493-3.524 11.493-7.855 0-3.08-2.61-5.754-6.401-7.04l1.028-2.469c5.343 1.612 9.081 5.267 9.081 9.509 0 5.728-6.819 10.388-15.201 10.388",
    style: {
      fill: "#cfbfed",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0300693
    },
    transform: "translate(-52.965 -21.45)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.284 175.522c-6 0-11.2-2.389-13.67-5.846l2.242-5.382a5.41 5.41 0 0 0-.066.84c0 4.332 5.156 7.856 11.494 7.856s11.493-3.524 11.493-7.856c0-4.331-5.155-7.853-11.493-7.853-4.56 0-8.509 1.823-10.365 4.46l2.244-5.385c2.351-1.02 5.137-1.61 8.121-1.61 8.382 0 15.201 4.66 15.201 10.388 0 5.729-6.819 10.388-15.201 10.388",
    style: {
      fill: "#9cd9f8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0300693
    },
    transform: "translate(-52.965 -21.45)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.387 120.456c-1.475-1.601-2.33-3.496-2.33-5.523 0-2.632 1.44-5.039 3.81-6.871l-1.48 12.394",
    style: {
      fill: "#f79bb3",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0300693
    },
    transform: "translate(-52.965 -21.45)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.917 181.437h-.05.05m-.113 0c-.025 0-.05-.003-.074-.003l.074.003m-.148-.003h-.046.046m-.124-.003h-.032.032m57.633-17.622-12.259-26.397-1.185-2.547-1.206-2.604-3.112-6.7-.65-1.397-8.25-17.766-.195-.418-6.177-13.3-.515-1.112-5.28-11.372 38.83 83.613",
    style: {
      fill: "#cdcfd1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0300693
    },
    transform: "translate(-52.965 -21.45)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.235 139.545c-6.34 0-11.494-3.524-11.494-7.855 0 4.331 5.154 7.855 11.494 7.855 5.224 0 9.638-2.398 11.027-5.666l-.747-1.618 1.206 2.604-.459-.986c-1.39 3.268-5.803 5.666-11.027 5.666m-15.202-7.855c0-5.728 6.82-10.388 15.202-10.388 1.95 0 3.81.262 5.524.72l-6.23-13.412-1.027-2.212 8.252 17.767-.995-2.143a21.39 21.39 0 0 0-5.524-.72c-8.382 0-15.202 4.66-15.202 10.388m1.348-37.712c1.027-1.545 2.593-2.888 4.533-3.921l-4.579-9.86 5.281 11.372-.702-1.512c-1.94 1.033-3.506 2.376-4.533 3.921",
    style: {
      fill: "#3293c5",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0300693
    },
    transform: "translate(-52.965 -21.45)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.308 105.98c-5.422-.627-9.567-3.852-9.567-7.734 0-2.171 1.298-4.142 3.39-5.565l6.177 13.3",
    style: {
      fill: "#c66e21",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0300693
    },
    transform: "translate(-52.965 -21.45)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.235 139.545c-6.34 0-11.494-3.524-11.494-7.855s5.154-7.853 11.494-7.853c2.709 0 5.2.648 7.168 1.725l3.112 6.7.747 1.617c-1.39 3.268-5.803 5.666-11.027 5.666",
    style: {
      fill: "#cc9396",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0300693
    },
    transform: "translate(-52.965 -21.45)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.114 181.45c-.687 0-1.39-.005-2.092-.01-.035-.003-.07-.003-.105-.003h-.113l-.074-.003h-.12c-.025 0-.053 0-.078-.003h-.032c-2.565-.028-5.021-.09-7.378-.18 4.083-7.11 7.805-14.91 11.086-23.05 5.962-1.408 10.252-5.28 10.252-9.825 0-2.77-1.595-5.29-4.191-7.156 4.222-13.489 7.172-27.226 8.502-39.772 1.912 4.014 7.32 6.959 13.758 7.161l6.23 13.412a21.39 21.39 0 0 0-5.524-.72c-8.382 0-15.202 4.66-15.202 10.388s6.82 10.387 15.202 10.387c5.288 0 9.948-1.855 12.671-4.664l12.26 26.396s-5.525 17.641-55.052 17.641m14.92-16.316c0 5.728 6.819 10.388 15.2 10.388 8.383 0 15.202-4.66 15.202-10.388s-6.82-10.388-15.201-10.388c-8.382 0-15.202 4.66-15.202 10.388m1.348-71.156c.272-4.87.261-9.496-.046-13.781l4.58 9.86c-1.941 1.033-3.507 2.376-4.534 3.921",
    style: {
      fill: "#cdb23d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0300693
    },
    transform: "translate(-52.965 -21.45)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.235 172.99c-6.34 0-11.494-3.524-11.494-7.856 0-4.331 5.154-7.853 11.494-7.853 6.336 0 11.493 3.522 11.493 7.853 0 4.332-5.157 7.856-11.493 7.856",
    style: {
      fill: "#cd3436",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0300693
    },
    transform: "translate(-52.965 -21.45)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.478 154.98c1.33-3.46 2.582-6.972 3.747-10.511.973 1.153 1.527 2.486 1.527 3.909 0 2.765-2.102 5.202-5.274 6.602",
    style: {
      fill: "#c66e21",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0300693
    },
    transform: "translate(-52.965 -21.45)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.235 175.522c-8.382 0-15.202-4.66-15.202-10.388s6.82-10.387 15.202-10.387 15.2 4.659 15.2 10.387c0 5.729-6.818 10.388-15.2 10.388m-11.494-10.388c0 4.332 5.154 7.856 11.494 7.856 6.336 0 11.493-3.524 11.493-7.856 0-4.331-5.157-7.853-11.493-7.853-6.34 0-11.494 3.522-11.494 7.853",
    style: {
      fill: "#cc9396",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0300693
    },
    transform: "translate(-52.965 -21.45)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.235 142.078c-8.382 0-15.202-4.66-15.202-10.388s6.82-10.388 15.202-10.388c1.95 0 3.81.262 5.524.72l.995 2.143.65 1.397c-1.97-1.077-4.46-1.725-7.17-1.725-6.339 0-11.493 3.521-11.493 7.853 0 4.331 5.154 7.855 11.494 7.855 5.224 0 9.638-2.398 11.027-5.666l.46.986 1.184 2.548c-2.723 2.81-7.383 4.665-12.671 4.665",
    style: {
      fill: "#7bb547",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0300693
    },
    transform: "translate(-52.965 -21.45)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.208 158.201c.43-1.068.854-2.142 1.27-3.221 3.172-1.4 5.274-3.837 5.274-6.602 0-1.423-.554-2.756-1.527-3.909.356-1.079.705-2.163 1.044-3.247 2.596 1.866 4.19 4.385 4.19 7.156 0 4.544-4.289 8.416-10.25 9.823M146.53 108.61c-6.44-.202-11.847-3.147-13.76-7.16.272-2.543.477-5.04.611-7.472 1.027-1.545 2.593-2.888 4.533-3.921l.702 1.512.515 1.112c-2.092 1.423-3.39 3.394-3.39 5.565 0 3.882 4.145 7.107 9.567 7.735l.194.417 1.027 2.212",
    style: {
      fill: "#c0315a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0300693
    },
    transform: "translate(-52.965 -21.45)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBirthdayHat5);
export default __webpack_public_path__ + "static/media/birthday_hat_5.6be68eea14546ba3f1aabdbe696b828d.svg";
export { ForwardRef as ReactComponent };